"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const planVariableTypes = Object.freeze({
    STR: "string",
    NUM: "number",
    FUNC: "function",
});
exports.default = planVariableTypes;
